module.exports = __webpack_public_path__ + "6de2b2081d23453b558816b6ff4a1ad8.jpg";